// Polyfill para módulo 'events' do Node.js
// Usado por recharts no browser

// EventEmitter básico para compatibilidade com recharts
class EventEmitter {
  constructor() {
    this._events = {};
  }

  on(event, listener) {
    if (!this._events[event]) {
      this._events[event] = [];
    }
    this._events[event].push(listener);
    return this;
  }

  once(event, listener) {
    const onceWrapper = (...args) => {
      listener.apply(this, args);
      this.removeListener(event, onceWrapper);
    };
    return this.on(event, onceWrapper);
  }

  emit(event, ...args) {
    if (this._events[event]) {
      this._events[event].forEach(listener => {
        listener.apply(this, args);
      });
    }
    return this;
  }

  removeListener(event, listener) {
    if (this._events[event]) {
      this._events[event] = this._events[event].filter(l => l !== listener);
    }
    return this;
  }

  removeAllListeners(event) {
    if (event) {
      delete this._events[event];
    } else {
      this._events = {};
    }
    return this;
  }

  listeners(event) {
    return this._events[event] || [];
  }

  listenerCount(event) {
    return this._events[event] ? this._events[event].length : 0;
  }
}

// Exportar EventEmitter como default e named export
export default EventEmitter;
export { EventEmitter };
